// extracted by mini-css-extract-plugin
module.exports = {"root":"EventSponsors_root__1eaA2","submitButton":"EventSponsors_submitButton__3-e_H"};